module.exports = __webpack_public_path__ + "static/TangleTower6-d07c104b15f9039ef6e884f95822f525.webp";